export const ruleCategories = [
  {
    id: "province",
    label: "قوانين المقاطعة",
    icon: "⚖",
    summary:
      "المرجع الأساسي الذي ينظم السلوك العام والهوية والواقعية وآلية التعامل داخل مقاطعة الراية.",
    alert:
      "مخالفة هذه القوانين قد تؤدي إلى عقوبات رقابية مشددة تبدأ من المحاسبة وقد تصل إلى الباند النهائي بحسب نوع المخالفة وتكرارها.",
    rules: [
      "يُمنع الإساءة للإدارة أو التشهير بها داخل المقاطعة أو التكتات أو البثوث.",
      "يُمنع اختيار جنس للشخصية لا يطابق الجنس الواقعي للاعب.",
      "يجب أن يكون اسم الهوية (اسم أول + اسم ثانٍ) واقعيًا. يُمنع استخدام أسماء غير لائقة أو مثيرة للحساسية دينيًا أو عرقيًا أو أسماء رموز أو قادة أو رؤساء.",
      "يُمنع طلب مطاردة رجال الأمن أو الترصد لهم بهدف القتل دون سبب تمثيلي وجيه.",
      "يُمنع التواصل غير الشرعي أثناء أي سيناريو قائم.",
      "يُمنع الترصد لأصحاب البثوث عبر البث المباشر.",
      "يُمنع الترصد أو المضايقة المتعمدة للمواطنين دون سبب تمثيلي.",
      "يُمنع الخروج من ديسكورد المقاطعة أثناء امتلاك رولات وظيفية معتمدة، ويجب تقديم الاستقالة رسميًا أولًا.",
      "يحق للرهينة الهروب إذا كان المجرم غافلًا ولم يُظهر سلاحًا ولم يسيطر على الموقف.",
      "الالتزام بالاحترام المتبادل واجب على الجميع.",
      "يُمنع استغلال الثغرات أو أي طريقة لزيادة الخبرة أو الأموال، والعقوبة قد تصل إلى الباند النهائي.",
      "يُمنع ذكر أو الترويج لمقاطعات أو سيرفرات أخرى أو نشر أسماء مدن خارج نطاق المقاطعة داخل اللعبة أو الديسكورد.",
      "يُمنع المقاومة بعد الإنعاش مباشرة.",
      "يُمنع إطلاق النار بوجود منسوبي الهلال الأحمر قرب موقع الحدث.",
      "يُمنع الطلب من الهلال الأحمر مغادرة الموقع بالقوة أو التهديد.",
      "يُمنع دخول نداءات الاستغاثة لأي سبب، ويُستثنى فقط النداءات في أماكن لا يمكن تجنبها ويعود التقدير للرقابة.",
      "يُمنع استغلال القدرات المحدودة بطرق غير واقعية أثناء حمل السلاح مثل الصفع أو التعطيل بهدف غير تمثيلي.",
      "يُمنع مضايقة أو قتل أو تهديد أو خطف موظفي الهلال الأحمر وموظفي كراج الميكانيك.",
      "يُمنع استخدام أي مواد غش أو هاك أو ملفات تؤثر على اللعب، والعقوبة باند نهائي وقد تشمل الحسابات المرتبطة.",
      "يُمنع طلب الإنعاش عبر التذاكر أو استخدام خارج، ويجب انتظار الوحدة الإسعافية.",
      "يُمنع طرح مواضيع دينية أو سياسية أو عرقية داخل المقاطعة أو الديسكورد.",
      "يُمنع أي إيحاءات أو تصرفات غير لائقة أو جنسية كتابةً أو حركات أو إشارات، والعقوبة قد تصل إلى الباند النهائي.",
      "أثناء مطاردة رجال الأمن يُمنع صعود الجبال بمركبات غير مخصصة بشكل غير واقعي.",
      "أثناء مطاردة الوحدات العسكرية يُمنع دخول المنازل أو التوجه لمناطق آمنة للهروب.",
      "يُمنع الصدم غير الواقعي في جميع الحالات.",
      "يُمنع الهروب عبر البحر دون قارب مجهز.",
      "مناطق البيع تُعد مناطق آمنة.",
      "محلات الملابس والأوشمة والحلاقة تُعد مواقع آمنة.",
      "يجب الالتزام بالقيادة الواقعية لجميع المركبات.",
      "يُمنع استخدام الشخصية الافتراضية أو الخروج عن الواقعية بشكل يضر التمثيل.",
      "يُمنع دخول المناطق المحظورة مثل الموانئ وقت الإغلاق أو الاستنفار ويجب المغادرة فورًا.",
      "المراقب خارج التمثيل تمامًا، ويُمنع التفاعل معه أو الحديث معه لأي سبب.",
      "يُمنع إدخال الحمولات للموانئ قبل افتتاحها رسميًا من الجهات المختصة.",
      "يجب تشغيل التصوير طوال فترة التواجد لحفظ الحقوق، ويحق للمراقب طلبه ويجب حفظه عند وجود بلاغ.",
      "يُمنع مضايقة أصحاب المتاجر أو التعرض لهم أثناء تعبئة متاجرهم.",
      "يُمنع تحريك المسقط بأي طريقة ويُعد ذلك ثغرة أو استغلالًا.",
      "يُمنع استعمال حركات غير لائقة على اللاعبين.",
      "يُمنع تثبيت المركبات بشكل غير واقعي على القلص.",
      "يُمنع تبادل الأموال أو الأسلحة أو المركبات أو الأشياء عالية القيمة بكميات كبيرة خارج الأنظمة، وأي تجاوز قد يؤدي إلى تصفير أو عقوبات.",
      "يُمنع بيع أو عرض أو تبادل حسابات اللعبة أو استخدام حساب شخص آخر، والمخالفة قد تؤدي إلى الباند الدائم وتصفير البيانات.",
      "يُمنع استخدام الحقنة في سيناريو السرقات.",
      "يُمنع استخدام الحقنة من قبل القطاعات العسكرية.",
      "يُمنع استخدام الحقنة أثناء وجود مسعف عند رأس المسقط.",
      "يُمنع على الهلال الأحمر المباشرة في الوحدات العسكرية أثناء وجود مواطنين يقومون بإنعاش زملائهم.",
      "يُمنع انتظار خروج اللاعبين من البيوت بغرض قتلهم بدون وجود سيناريو قائم خلال آخر 15 دقيقة.",
      "يُمنع بدء أي سيناريو إجرامي ضد اللاعبين أثناء قيامهم بتجهيز أو تعبئة الحمولات سواء عند البيوت أو مناطق العمل أو في محيطها.",
      "يُمنع ملاحقة أصحاب الحمولات بقصد بدء فايت أو اعتراضها قبل وصولها للميناء.",
      "يُعاقب من يخالف هذه الاشتراطات بالسجن لمدة 1000 شهر بتهمة ترصد لحمولة وبيوت.",
      "يُمنع منعًا باتًا استخدام أي حركة من قائمة الحركات مع المسقطين.",
      "التنمر على التأتأة أو اللدغة بالأحرف وما يكون تحت هذا النطاق يعرضك لعقوبة باند 7 أيام وقد تصل إلى باند نهائي.",
      "يُمنع السب والقذف أو اللعن للشخص نفسه أو للأهل، ويعرضك ذلك لعقوبة شديدة اللهجة قد تصل إلى باند نهائي من المقاطعة.",
    ],
  },
  {
    id: "discord",
    label: "قوانين الديسكورد",
    icon: "◉",
    summary:
      "ضوابط المجتمع الرسمي في ديسكورد للحفاظ على الاحترام والتنظيم وسهولة الوصول للإدارة والقنوات الصحيحة.",
    alert:
      "مخالفات ديسكورد قد تنعكس على حسابك داخل المقاطعة أيضًا إذا تضمنت إساءة أو انتحالًا أو تجاوزات جسيمة.",
    rules: [
      "يُمنع نشر روابط أو اختصارات أو رموز للترويج لسيرفرات أخرى.",
      "يُمنع وضع أسماء خادشة للحياء أو الذوق العام.",
      "يُمنع إرسال صور أو محتوى مخل بالآداب.",
      "يُمنع الإساءة لأعضاء المقاطعة.",
      "يُمنع مناقشة المواضيع الدينية أو السياسية أو العرقية.",
      "يُمنع السخرية والاستهزاء بالآخرين، وقد تصل العقوبة إلى منع الكتابة أو الباند.",
      "التواصل مع إدارة الرقابة يكون عبر التكت فقط، ويُمنع المنشن.",
      "يُمنع استخدام كروت أو برامج تغيير الصوت في الرومات الصوتية.",
      "الاحترام مبدأ أساسي يجب على الجميع الالتزام به.",
      "يُمنع استخدام أسماء غير لائقة.",
      "يُمنع انتحال الشخصيات الإدارية، والعقوبة قد تصل إلى باند نهائي.",
      "يُمنع نشر أي محتوى خادش أو مخل، والعقوبة قد تصل إلى حظر نهائي.",
      "السبام قد يؤدي إلى منع الكتابة أو الحديث.",
      "تُقبل الشكاوى خلال 24 ساعة من الحدث، وبعدها تخضع للتقييم حسب الحالة.",
    ],
  },
  {
    id: "announcements",
    label: "تنويهات عامة",
    icon: "▸",
    summary:
      "ملاحظات تشغيلية مهمة تخص الحسابات والربط والتعويضات والتحلل والعقوبات المالية والإدارية داخل المقاطعة.",
    alert:
      "هذه التنويهات مكملة للقوانين الأساسية، وأي مخالفة فيها قد تؤثر على حسابك أو ممتلكاتك أو صلاحية دخولك لبعض الأنظمة.",
    rules: [
      "ربط حسابك بأي حساب آخر مسؤوليتك، وإذا تم حظر الشخص المرتبط قد تُمنع من الدخول حتى فك حظره.",
      "حسابك مسؤوليتك بالكامل، ويجب الدخول بالحساب الأساسي الذي توجد عليه الخبرة.",
      "يُمنع التواجد أو الدعم أو الترويج لسيرفرات الغش أو الهاكات، والعقوبة باند دائم.",
      "التلاعب أو الكذب في تكتات التعويض يعرضك للمحاسبة.",
      "قد يتم سحب الأسلحة تلقائيًا عند تغيير الهوية، ولا تعويض على المسحوب.",
      "قد يتم خصم خبرة عند دهس مواطن، ولا يُفتح تكت إلا إذا كان الخصم بسبب خطأ برمجي.",
      "قد يتم سحب المنازل تلقائيًا عند الإهمال أو عدم الدخول فترة طويلة، ولا تعويض.",
      "في حال التحلل تُسحب الممنوعات أو الأسلحة تلقائيًا ولا تعويض، ويُمنع التحلل أثناء السيناريو.",
      "عدم تسديد المخالفات أو الغرامات الرقابية قد يمنعك من الميناء أو الوظائف المعتمدة.",
    ],
  },
  {
    id: "smuggling",
    label: "قوانين التهريب",
    icon: "▣",
    summary:
      "القواعد المنظمة لدخول الميناء والتهريب وآلية التصعيد مع الأمن بما يحافظ على التوازن والواقعية داخل السيناريو.",
    alert:
      "التهريب من أكثر الأنشطة حساسية داخل المقاطعة، وأي خروج عن الأنظمة فيه قد يعرضك لعقوبات رقابية أو جنائية مباشرة.",
    rules: [
      "يُسمح بدخول الميناء للتهريب حسب أنظمة السيرفر باستخدام القارب.",
      "يُمنع استخدام لبس الوظائف العامة للتمويه لتشتيت الأمن حسب الأنظمة.",
      "يُمنع قتل وحدات التفتيش الثابتة في الميناء، أمن 1 وأمن 2.",
      "يُمنع القتل العشوائي للعساكر، ويُكتفى بإسقاط من يعترض طريقك أو يحاول اعتقالك ضمن السيناريو.",
      "أقل عدد ممنوعات لدخول الميناء هو 50 شدة، وخلاف ذلك يعرضك للمحاسبة.",
      "عند استحالة الهروب لا يُمنع تسليم نفسك حفاظًا على حياتك.",
      "يُمنع استخدام السلاح من القارب ضد أشخاص على رصيف الميناء، وينطبق ذلك على الجميع.",
      "إذا رفض المهرب الاستسلام ولم يستجب للتحذيرات، يحق للأمن إسقاطه إذا كان مسلحًا فقط.",
      "يُمنع دخول الميناء بدون ممنوعات بهدف إطلاق النار أو حماية صديق.",
      "عند رفع منطقة محظورة أو إغلاق الميناء، يُمنع الدخول ويجب المغادرة فورًا.",
      "إذا لم يتم كشفك، يُمنع كشف نفسك عمدًا بهدف تبادل إطلاق النار.",
      "يُمنع تعريض المواطنين أو التجار للخطر أثناء التهريب، ولا قتل دون هدف ضمن السيناريو.",
      "يُمنع الوقوف خلف الشبك داخل الميناء، ويعطى تحذير 5 ثوانٍ ثم يحق للأمن القبض عليك.",
      "الفصل أثناء التهريب يعرضك لعقوبات شديدة.",
    ],
  },
  {
    id: "crime",
    label: "قوانين الإجرام",
    icon: "♟",
    summary:
      "الضوابط التي تحكم السيناريوهات الإجرامية والتهديد والخطف وإطلاق النار والتعامل مع الأمن داخل المشاهد النشطة.",
    alert:
      "أي تخريب أو عشوائية أو كسر لواقعية السيناريو الإجرامي قد يعرّضك للمحاسبة وقد يصل إلى الباند النهائي من المقاطعة.",
    rules: [
      "ممنوع طلب إزالة الدوريات أو رجال الأمن من الموقع ويعتبر ذلك تخريب تمثيل.",
      "يجب الجدية في السرقات وعدم التراخي بين المجرمين ورجال الأمن.",
      "يُمنع عليك تهديد أي مواطن، ويحق لك تهديده في حالتين فقط: أخذه رهينة لسيناريو أو طلب مبلغ مالي بحد أقصى 30 ألف.",
      "يُمنع قتل أو اختطاف المفاوض داخل السيناريو.",
      "يُمنع تهديد رجل الأمن لاستخدامه في السرقة، ويُسمح فقط ضمن سبب تمثيلي واضح مثل فك زميل قبل سجنه.",
      "يُمنع دخول موقع السرقة إلا بعد انتهاء السيناريو بالكامل.",
      "يُمنع القتل بدون سبب أو هدف، ويجب التحذير أولًا ثم الإسقاط عند عدم التجاوب.",
      "بعد قتل شخص يجب تمثيل الهروب مباشرة وعدم انتظار الأمن لتبادل إطلاق النار.",
      "يحق لك طلب واحد فقط على جميع الرهائن، والزيادة تعرضك للمحاسبة.",
      "يُمنع الخروج من السيرفر أثناء سيناريو قائم، وعند العودة بسبب مشكلة تقنية يجب تسليم نفسك للأمن.",
      "يُمنع سرقة مركبات العاملين في الوظائف العامة.",
      "يُمنع التواصل غير الشرعي أثناء السيناريو.",
      "يُمنع إطلاق النار خارج نداء الاستغاثة إذا وصلت والنداء مرفوع مسبقًا.",
      "يُمنع الإطلاق العشوائي بدون سبب.",
      "يُمنع التعرض لمركبات الشرطة العسكرية، ويُمنع على منسوبيها الدخول في السيناريو والتفاعل به.",
      "يُمنع تكرار السلوك الإجرامي خلال مدة قصيرة مقدارها 15 دقيقة.",
      "يُمنع الإجرام فوق أسطح المباني العالية منعًا باتًا.",
      "يُمنع التعرض لنقاط التفتيش أو إطلاق النار عليها.",
      "يُمنع استخدام جركل البنزين لغرض الإجرام، ويُمنع حرق المسقط أو المركبات.",
      "يُمنع الإجرام في جزيرة فرسان بشكل نهائي.",
      "يُمنع التخريب واستغلال ثغرة المنظور الثالث.",
      "تقدير الحياة إلزامي، ويُمنع مقاومة السلاح الناري بأسلحة بيضاء بشكل غير منطقي.",
      "يُمنع التجول بعدة الغوص داخل المدينة أو الإجرام بها، وتُستخدم للغوص داخل البحر فقط.",
      "يُمنع بدء أي فعل إجرامي أثناء إعلان ممنوع الإجرام.",
      "التخريب بأي شكل من الأشكال قد تصل عقوبته إلى الباند النهائي من المقاطعة.",
    ],
  },
  {
    id: "theft",
    label: "قوانين السرقات",
    icon: "▰",
    summary:
      "تفاصيل أعداد المجرمين والأمن وحدود التدخل وقواعد الهروب الخاصة بكل نوع من أنواع السرقات داخل المقاطعة.",
    alert:
      "تجاوز الأعداد أو كسر شروط السرقة أو استغلال الثغرات أثناء التنفيذ قد يؤدي إلى إلغاء السيناريو ومحاسبة جميع المشاركين.",
    rules: [
      "البنك الفرعي: الحد الأدنى 3 مجرمين، الحد الأقصى 4، مع تدخل خارجي واحد، والحد الأقصى للأمن 6.",
      "البنك المركزي: الحد الأدنى 6 مجرمين، الحد الأقصى 8، والحد الأقصى للأمن 10.",
      "المجوهرات: الحد الأدنى 2 مجرمين، الحد الأقصى 4، مع تدخل خارجي واحد، والحد الأقصى للأمن 6.",
      "البقالة أو البنك أو الصيدلية أو البار: الحد الأدنى 2، الحد الأقصى 3، مع تدخل خارجي واحد، والحد الأقصى للأمن 5.",
      "متجر الأسلحة: الحد الأدنى 2، الحد الأقصى 3، مع تدخل خارجي واحد، والحد الأقصى للأمن 5.",
      "المستودعات الطبية، عدة البقالة: الحد الأدنى 4 مجرمين، الحد الأقصى 6، والحد الأقصى للأمن 7.",
      "سرقة المنازل: الحد الأقصى شخصان، وأثناء منع الإجرام تُسمح بدون سلاح فقط، ويجب تمثيل الهروب مباشرة بعد السرقة، وتُمنع مركبات السوبر كار والحلبات والدراق والدبابات.",
      "اعتراض موكب نقل السجون: دوريتان بإجمالي 3 عساكر، ويُسمح مرة واحدة خارج حدود السجن المركزي، وعدد المجرمين 2، ويُمنع إسقاط السائق بعد فك الأصفاد.",
      "الدواجن: الحد الأدنى 3 مجرمين، الحد الأقصى 5، والحد الأقصى للأمن 7.",
      "الفنون: الحد الأدنى 4 مجرمين، الحد الأقصى 6، والحد الأقصى للأمن 8.",
      "المختبرات: الحد الأدنى 4 مجرمين، الحد الأقصى 6، والحد الأقصى للأمن 8.",
      "خزنة الشرطة: الحد الأدنى 4 مجرمين، الحد الأقصى 6، والحد الأقصى للأمن 8.",
      "يُمنع استخدام ثغرات الراديو، وذلك يعرضك لعقوبة استخدام الثغرات البرمجية.",
      "يجب عدم مباشرة الهروب من أي سرقة قبل مرور 15 دقيقة.",
    ],
  },
  {
    id: "port",
    label: "قوانين الميناء",
    icon: "⚓",
    summary:
      "تعليمات تنظيم الدخول والاصطفاف والتعامل مع الأمن والحمولات داخل الميناء ومناطق التهريب التابعة له.",
    alert:
      "الميناء منطقة تشغيل حساسة، وأي فوضى أو دخول مخالف أو تعطيل لحركة الميناء قد يؤدي إلى تشديد العقوبات فورًا.",
    rules: [
      "عند الانتظار أمام بوابة الميناء يجب الالتزام بمسافة آمنة بين المركبات.",
      "عند دخول مواطن بشكل غير قانوني يتم إبلاغ الأمن، وإذا أحدث فوضى يحق سجنه بتهمة عدم الانصياع.",
      "في حال التصادم يحق للأمن مخالفتك وإرجاعك لآخر الصف حسب تقديره، مع ترك مسافة لا تقل عن 5 أمتار.",
      "الدخول بعكس السير من بوابة الخروج يحق للأمن معه إطلاق النار على الكفرات واتخاذ الإجراءات.",
      "لا يحق لك إدخال راكب معك، ولكل شخص مركبته أو مركبة مستأجرة.",
      "تنفيذ أوامر الأمن إلزامي، ويُمنع الجدال، والمخالفة قد تؤدي إلى السجن.",
      "يجب الالتزام بقوانين الميناء والتهريب لتجنب المحاسبة.",
      "سيتم تشديد العقوبات على المخالفين والمتهاونين.",
      "يُمنع دخول حمولة غير واقعية للميناء، وخلاف ذلك سيتم تشديد العقوبات على المخالفين.",
      "يُمنع على أي عسكري الدخول إلى مناطق التهريب.",
      "يُمنع منعًا باتًا على أي عسكري الترصد للمهربين.",
      "أقل عدد ممنوعات لدخول الميناء هو 50 شدة.",
      "يُمنع دخول الميناء بغرض التخريب بشكل نهائي.",
      "إذا كان يوجد إطلاق نار داخل مواقع البيع يحق للوحدات العسكرية التدخل.",
    ],
  },
  {
    id: "participation",
    label: "قوانين المشاركة",
    icon: "♣",
    summary:
      "إرشادات النشر داخل قسم المشاركات لضمان أن يبقى المحتوى مناسبًا للمقاطعة ويعكس جودتها وإبداع مجتمعها.",
    alert:
      "قسم المشاركة مخصص لإبراز محتوى المقاطعة فقط، وأي استخدام خارج هذا الإطار قد يؤدي إلى حذف المشاركة والمحاسبة.",
    rules: [
      "يُمنع نشر فيديوهات أو صور مخلة بالآداب.",
      "يُمنع نشر محتوى من خارج مقاطعة الراية.",
      "يُمنع نشر محتوى بهدف الاستهزاء على الأشخاص أو القطاعات.",
      "يُمنع إرسال مشاركة تخص شكوى أو خطأ برمجي.",
      "يُمنع الكتابة أو التحدث في رومات المشاركة.",
      "يُمنع التطرق للسياسة أو الدين أو العنصرية.",
      "يُمنع نشر ما يعتبر إهانة للوظائف العسكرية.",
      "الروم مخصص لمقاطع من داخل المقاطعة فقط.",
      "احرص على إبراز الإبداع بما يليق بالمقاطعة.",
      "المشاركة تعني تقديم شيء جميل يبرز جمال المقاطعة.",
    ],
  },
  {
    id: "store-rules",
    label: "قوانين المتجر",
    icon: "▣",
    summary:
      "بنود خاصة بمتجر مقاطعة الراية والخدمات الرقمية، وتشمل الاسترداد والاستبدال والحظر والتصفير وحقوق العملاء.",
    alert:
      "باستخدام مواد المتجر أو الاستفادة من أي خدمة رقمية، يقر العضو بالموافقة على شروط المتجر وسياسات السيرفر.",
    rules: [
      "قانون رقم 1: بخصوص موضوع /unba، هذه بنود خاصة بقوانين السيرفر. في حال خرقها، يخضع العضو لبنود الحظر (الباند) من سيرفر مقاطعة الراية نتيجة مخالفة قوانين السيرفر، وذلك بعد بدء الاستفادة من أي خدمة، فإنه لا يحق له المطالبة باسترداد أي مبلغ مدفوع، كون الخدمة رقمية مستهلكة ولا يمكن إرجاعها.",
      "قانون رقم 2: يعد الحظر مخالفة صريحة لقوانين السيرفر، ويحق لإدارة مقاطعة الراية تصفير (حذف) الحساب بالكامل وحظره نهائيًا.",
      "قانون رقم 3: يمنع العضو المحظور أو المصفر حق الاعتراض خلال مدة أقصاها 7 أيام عمل من تاريخ تنفيذ القرار، ويتم تقديم الاعتراض عبر فتح تذكرة في برنامج الديسكورد الخاص بالسيرفر.",
      "قانون رقم 4: تلتزم الإدارة خلال هذه المدة بالرد وتوضيح سبب الحظر أو التصفير، ويكون التوضيح بإحدى الوسائل التالية: نص مكتوب، صورة، مقطع فيديو، تسجيل صوتي، أو غير ذلك حسب ما يتوفر لدى الإدارة خلال المدة المحددة. بعد صدور القرار نهائيًا داخل السيرفر، لا يحق للعضو الاعتراض عليه مرة أخرى داخل السيرفر، مع احتفاظه بحقه في المطالبة لدى الجهات المختصة في المملكة العربية السعودية.",
      "قانون رقم 5: يحق لإدارة مقاطعة الراية اتخاذ إجراء نهائي بالحظر والتصفير الكامل للحساب في حال تكرار المخالفات، أو التسبب بمشاكل للاعبين الآخرين.",
      "قانون رقم 6: يشمل الحظر، على سبيل المثال لا الحصر، الأفعال التالية: السب أو الشتم، القذف، التشهير، الإساءة اللفظية أو الفعلية، استغلال الثغرات، مضايقة اللاعبين، أو أي مخالفة أخرى لقوانين السيرفر.",
      "قانون رقم 7: عند استخدام مواد المتجر، فإنك توافق على جميع شروط متجر مقاطعة الراية، بما في ذلك عدم المطالبة بأي استرداد مالي أو تعويض بعد تنفيذ الخدمة.",
      "قانون رقم 8: في حال تصفير حسابك بالكامل، يتم سحب جميع ممتلكاتك من المتجر ومن داخل السيرفر بشكل تلقائي دون أي استثناء، ولا يحق لك المطالبة بأي تعويض مباشر أو غير مباشر من إدارة السيرفر أو المتجر.",
      "قانون رقم 9: لا يتم الاسترجاع أو الاستبدال إلا إذا كان المنتج مخالفًا لما هو موضح في الوصف، أو في حال وجود خلل يمنع الاستفادة منه.",
      "قانون رقم 10: يجب تقديم دليل واضح عبر تذكرة في الديسكورد خلال مدة أقصاها 7 أيام من تاريخ الاستلام، ولا يتم الاستبدال بسبب اختلاف الذوق أو تغيير الرأي طالما أن المنتج مطابق للوصف.",
      "قانون رقم 11: تنتهي مسؤولية متجر مقاطعة الراية بمجرد تسليم كود المنتج بشكل صحيح، ويتحمل العميل كامل المسؤولية في اختيار المنتج المناسب، وإدخال البيانات الصحيحة، واستخدام الكود بعد الاستلام.",
      "قانون رقم 12: بعد تأكيد الدفع لا يمكن إلغاء الطلب، إلا في حالات استثنائية تقررها إدارة متجر مقاطعة الراية. يتم الدفع عبر وسائل إلكترونية آمنة، ولا يحتفظ المتجر بأي معلومات حساسة تتعلق بوسيلة الدفع.",
      "قانون رقم 13: يتم عرض المنتجات بصور ونماذج توضيحية، وقد تختلف الألوان أو التفاصيل حسب الإضاءة أو الشاشة. بوضع المنتج في سلة الشراء، يقر العميل باطلاعه الكامل على وصف المنتج ومحتواه.",
      "قانون رقم 14: يلتزم متجر مقاطعة الراية بعدم بيع أو مشاركة بيانات العملاء مع أي جهة خارجية، وتستخدم فقط لمعالجة الطلبات وتحسين الخدمات. جميع المحتويات المعروضة مملوكة للمتجر، ويمنع استخدامها أو إعادة نشرها دون إذن خطي.",
      "قانون رقم 15: تستقبل الشكاوى خلال مدة أقصاها 7 أيام عمل من تاريخ الاستلام، مع إرفاق الأدلة عبر الديسكورد.",
      "قانون رقم 16: المنتجات المقدمة هي منتجات رقمية ترفيهية خيالية داخل السيرفر، ولا تمثل الواقع، ولا توجد أي علاقة بينها وبين أي جهة رسمية أو شركة عالمية.",
      "قانون رقم 17: تحتفظ إدارة متجر مقاطعة الراية بحق تعديل هذه الشروط في أي وقت، وتخضع هذه الاتفاقية لأنظمة وقوانين المملكة العربية السعودية، ويكون الاختصاص القضائي للمحاكم المختصة داخل المملكة.",
    ],
  },
];
